export default function init() {
  const productSpotlight = document.querySelectorAll('.ProductSpotlight')
  if (!productSpotlight.length) return

  productSpotlight.forEach((section) => {
    const groupTitles = section.querySelectorAll(
      '.ProductSpotlight__GroupTitle',
    )
    groupTitles.forEach((title) => {
      title.addEventListener('click', () => {
        groupTitles.forEach((groupTitle) => {
          groupTitle.classList.remove('is-active')
          groupTitle.setAttribute('aria-pressed', 'false')
        })
        title.classList.add('is-active')
        title.setAttribute('aria-pressed', 'true')
        const value = title.textContent ?? ''
        ;(section as HTMLElement).dataset.selectedGroupTitle = value

        const products = section.querySelectorAll('.ProductSpotlight__Product')
        products.forEach((product) => {
          const productGroup = product.getAttribute('data-group-title') ?? ''
          if (value && (productGroup === value || productGroup === '')) {
            product.classList.add('is-showing')
          } else {
            product.classList.remove('is-showing')
          }
        })
      })
    })
  })
}
